import React, { Suspense, lazy, useEffect } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import Loader from "../Loader/Loader";
import { setPublicAccessToken } from "../../actions/globalAction";

const LoadablePublicDashboard = lazy(() => import("./PublicDashboardContent"));

const PublicWithToken = (props) => {
    useEffect(() => {
        if (props.match.params.token) {
            props.setPublicAccessToken(props.match.params.token);
        }
    }, []);
    return (
        <Suspense fallback={<Loader className="fullpage-loader" />}>
            <Switch>
                <Route path={"/public/:token/dashboard/:id"} render={(props) => <LoadablePublicDashboard {...props} />} />
            </Switch>
        </Suspense>
    );
};

const mapStateToProps = (state) => ({
    publicAccessToken: state.globalReducer.publicAccessToken,
});

const mapDispatchToProps = (dispatch) => ({
    setPublicAccessToken: (arg) => dispatch(setPublicAccessToken(arg)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicWithToken);
